import React from 'react';
import './styles.css';
import deviceInfo from '../../deviceInfo';
import { FormattedMessage } from 'react-intl';

function CustomLoader()
{
	const device = deviceInfo();

	const handleBack = () =>
	{
		if (window.location.host.includes('localhost'))
		{
			window.location = `${window.location.origin}/desktop_room`;
		}
		else
		{
			window.location = `https://${window.location.hostname}/desktop_room`;
		}
	};

	const handleExit = () =>
	{
		window?.electron?.ipcRenderer?.sendMessage('quitApp');
	};

	return (
		<div className='loadngCntnr'>
			<span className='reTxt textCntr'>
				<FormattedMessage
					id='waiting_msg'
					defaultMessage='Sit back and relax while we establish your video connection'
				/>
			</span>
			<div className='loading'>
				<div className='dot' />
				<div className='dot' />
				<div className='dot' />
				<div className='dot' />
				<div className='dot' />
			</div>
			{(device.platform === 'desktop' && device.name === 'electron') && <div className='flexRow jCntr'>
				<span className='dashboardBtnPosition pointer mrgnRMD' onClick={handleBack}>
					Go To Dashboard
				</span>
				<span className='exitbtnPosition pointer' onClick={handleExit}>
					Exit
				</span>
			</div>}
		</div>
	);
}

export default CustomLoader;